export default "__VITE_ASSET__6e6e2206__"